<div class="otp-input-container">
  <input
    #otpInput
    *ngFor="let value of values; let i = index; trackBy: trackByIndex"
    [attr.aria-label]="'OTP digit ' + (i + 1)"
    [attr.data-index]="i"
    [attr.disabled]="disabled ? '' : null"
    [attr.inputmode]="inputType === 'number' ? 'numeric' : 'text'"
    [id]="'otp-input-' + i"
    [name]="'otp-digit-' + i"
    [pattern]="inputType === 'number' ? '[0-9]' : '.*'"
    [placeholder]="placeholder"
    [type]="inputType === 'number' ? 'text' : inputType"
    [value]="values[i]"
    (focus)="onFocus()"
    (input)="onInput($event, i)"
    (keydown)="onKeyDown($event, i)"
    (paste)="onPaste($event)"
    class="otp-input"
    autocomplete="one-time-code"
    maxlength="1"
  />
</div>
